import styled from "styled-components";

export const Scroll = styled.div`
  overflow-y: auto;
  flex: 1;
  background: #fafbfb;
`;

export const StepBody = styled.div`
  padding: 12px 14px 16px;
`;

export const OptionsCard = styled.div`
  background: ${(p) => p.theme.tokens.colors.surface};
  border-radius: 16px;
  border: 1px solid ${(p) => p.theme.tokens.colors.line};
  padding: 4px 14px;
`;

export const ChoiceList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
`;

export const Footer = styled.div`
  padding: 12px 16px calc(0px + env(safe-area-inset-bottom));
  border-top: 1px solid ${(p) => p.theme.tokens.colors.line};
  flex-shrink: 0;
`;

export const ConfirmButton = styled.button`
  width: 100%;
  border: none;
  cursor: pointer;
  border-radius: 16px;
  padding: 16px 22px;
  font-family: ${(p) => p.theme.tokens.font.family};
  font-weight: 800;
  font-size: 16.5px;
  color: #fff;
  background: ${(p) => p.theme.tokens.gradients.header};
  box-shadow: ${(p) => p.theme.tokens.shadows.cta};
`;
